<template>
<transition name='fade'>
  <div id='un-introduction' v-show='show'>
    <div class='un-introduction-wrap'>
      <h2>Customize</h2>
      <ul>
        <li>
          <span class='num'>1</span>
          <span class='text'>Upload an image.</span>
        </li>
        <li>
          <span class='num'>2</span>
          <span class='text'>Drag your image to the desired position on the product, and use the options to edit.</span>
        </li>
        <li>
          <span class='num'>3</span>
          <span class='text'>Click DONE to add the customized product to your shopping cart.</span>
        </li>
      </ul>
      <div class='add-image-to-start'>
        <button class='btn btn-secondary' v-tap='promptUserForImageFile'>
          Get Started
        </button>
      </div>
    </div>
  </div>
</transition>
</template>
<script>
import {
  unUi,
  PROMPT_USER_FOR_IMAGE_FILE_EVENT,
  HIDE_INTRO_EVENT
} from '@/components/EventBuses'
import {isDevelopment} from '$utilities/environment'

export default {
  props: [
    'show'
  ],

  mounted () {
    if (isDevelopment()) {
      // Bind escape to kill the intro screen.
      document.addEventListener('keyup', (event) => {
        if (event.keyCode === 27) {
          unUi.$emit(HIDE_INTRO_EVENT)
        }
      })
    }
  },

  methods: {
    promptUserForImageFile () {
      unUi.$emit(PROMPT_USER_FOR_IMAGE_FILE_EVENT)
    }
  }

}
</script>
<style lang='scss'>
#un-introduction {
  @include full_wh;

  position: fixed;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 10000;

  .un-introduction-wrap {
    position: relative;
    width: 60%;
    max-width: 34rem;
    left: 15%;
    top: 50%;
    transform: translateY(-50%);
    color: white;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);

    h2 {
      color: white;
      margin-bottom: 2rem;
      margin-left: 3em;
      text-transform: uppercase;
    }

    ul {
      margin: 0;
      padding: 0;

      li {
        list-style-type: none;
        margin-bottom: 3.5rem;
        position: relative;

        .num {
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          border: 1px solid white;
          width: 2.5rem;
          height: 2.5rem;
          line-height: 2.5rem;
          border-radius: 50%;
          text-align: center;
          font-weight: bold;
        }

        .text {
          // padding-top: 0.5rem;
          margin-left: 3em;
          display: block;

          @include line-height(1.85);
        }
      }
    }

    .add-image-to-start {
      margin-top: 4rem;

      button {
        display: block;
        width: 100%;
        height: 3rem;
        font-size: 1.1em;

        &:focus {
          outline: none;
        }

        &:active {
          background-color: rgb(0, 0, 255);
          border-color: rgb(0, 0, 255);
          color: white;
        }
      }

      @include respond-to("small") {
        margin-top: 3rem;
      }
    }

    @include respond-to("small") {
      // text-align: center;
      left: initial;
      margin: 0 auto;
      width: 66%;
      max-width: 34rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/product-designer/Introduction.vue